import React from "react";

const BlogHeader = ({HeaderTitle, HeaderDesc}) => (
    <header className="py-24 text-white bg-gradient">
        <div className="blog-container">
            <h1 className="text-4xl font-extrabold">{HeaderTitle}</h1>
            <p>{HeaderDesc}</p>
        </div>
    </header>
)

export default BlogHeader